var exports = {
  "k": "x93eb46d8--ab854d--container",
};

module.exports = exports;
